import { useState, useEffect, useCallback } from 'react';
import { authenticatedFetch } from '../../../../utils/api';

export const useOccurrenceData = (deviceInfo, preloadedData = null) => {
    const [occurrenceData, setOccurrenceData] = useState(preloadedData?.occurrenceData || []);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [dataFetched, setDataFetched] = useState(
        preloadedData !== null && preloadedData.occurrenceData?.length > 0
    );

    const fetchOccurrenceData = useCallback(async () => {
        if (!deviceInfo) return;

        setLoading(true);
        setError(null);
        try {
            const res = await authenticatedFetch('/ManagerReport/GetOccurrenceData', {
                method: 'GET',
            });

            if (!res.ok) {
                throw new Error('Failed to fetch occurrence data');
            }

            const response = await res.json();

            if (response.message != null) {
                setError(response.message);
            } else {
                setOccurrenceData(response);
            }
        } catch (ex) {
            console.error('Error fetching occurrence data:', ex);
            setError(ex.message);
        } finally {
            setDataFetched(true);
            setLoading(false);
        }
    }, [deviceInfo]);

    useEffect(() => {
        if (dataFetched || !deviceInfo) return;
        fetchOccurrenceData();
    }, [deviceInfo, dataFetched, fetchOccurrenceData]);

    return {
        occurrenceData,
        loading,
        error,
        dataFetched,
        refresh: fetchOccurrenceData,
    };
};
